/**
 * Blueprint Page - April 2026
 * Password-gated fullscreen slide deck viewer
 */

import React from 'react';
import { PitchDeck, BLUEPRINT_APRIL_2026 } from '@components/press/pitch-deck';

export const BlueprintApril2026Page: React.FC = () => <PitchDeck edition={BLUEPRINT_APRIL_2026} />;
